import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './EvServiceConfigPanel.html?raw';
import lang from 'dojo/_base/lang';
import _uiFrameMixin from '../../../../moreCore/UI/Container/uiFrame';
import _GlobalSelectEntityDialogsMixin from '../../../_loadingHelpers/_GlobalSelectEntityDialogsMixin';

import { TabContainer } from "../../../../moreCore/_loadingHelpers/Tabbing";

import GenericDialog from '../../../../moreCore/UI/GenericDialog/GenericDialog';
import EntityStore from '../../../../moreCore/Tools/EntityStore';
import StaticTable from '../../../../moreCore/UI/StaticTable/StaticTable';
import { StringHelpers } from "../../../../more/Helpers";

import CheckBox from '../../../../moreCore/UI/CheckBox/CheckBox';
import HintBox from '../../../../moreCore/UI/HintBox/HintBox';
import { SelectEntityDialogTypes } from "../../../../moreCore/_loadingHelpers/SelectEntityDialog";
import { VAM2types } from "../../../_loadingHelpers/VAMv2Types";

class EvServiceConfigPanel extends compose(_uiFrameMixin, _GlobalSelectEntityDialogsMixin) {
    templateString: any = template;

    private tableContainer: HTMLDivElement;
    private serviceTable: MdsLax<InstanceType<typeof StaticTable>>;

    private serviceCheckboxMap: Map<string, MdsLax<InstanceType<typeof CheckBox>>>;
    private childServiceHintboxMap: Map<string, MdsLax<InstanceType<typeof HintBox>>>;

    private serviceTableRowConfig: StaticTable.RowConfig = {
        headings: [
            "EvServiceConfigPanel_Heading_ServiceName",
            "EvServiceConfigPanel_Heading_CreateEvTaskBeyond",
            "EvServiceConfigPanel_Heading_ChildService",
            "EvServiceConfigPanel_Heading_CreateEvTaskBeyond"
        ],
        attributes: [
            "description",
            "createEvTaskBeyond",
            "childService",
            "createEvTaskBeyondChild"],
    };
    private serviceTableConfig: StaticTable.Layout = {
        label: "Auswahl konfigurieren",
        name: "evServiceConfigPanel",
        rows: [(this as any).serviceTableRowConfig],
    }

    private serviceTableFormatter(cell: StaticTable.StaticTableCell<VAM2types.EvService>) {
        let name = cell.name;
        let entity = cell.entity;
        let node = cell.contentnode;

        switch (name) {
            case "createEvTaskBeyond":
                this.UiModder.domConstruct.empty(node);

                if (entity.EL_ht_service_ev_serv_ev_task_descript_service?.length > 0) {
                    var checkbox: MdsLax<InstanceType<typeof CheckBox>> = this.serviceCheckboxMap.get(entity.ID);
                    if (!checkbox) {
                        checkbox = new CheckBox();
                        this.serviceCheckboxMap.set(entity.ID, checkbox);
                        checkbox.on("change", lang.hitch(this, this._onChangeServiceCheckbox, entity.ID, "parent"));
                    }
                    checkbox.setValue(entity.createEvTaskBeyond, true);
                    checkbox.placeAt(node);
                }
                return true;
            case "childService":
                this.UiModder.domConstruct.empty(node);
                if (entity.EL_vt_services_main_service?.length > 0) {
                    var hintbox = this.childServiceHintboxMap.get(entity.ID);
                    if (!hintbox) {
                        hintbox = new HintBox();
                        hintbox._setValueAttributeAttr("ID");
                        hintbox.setLabelAttribute("description");
                        hintbox.setInputNodeReadonly(true);
                        hintbox.addInlineButton(lang.hitch(this, this._onClickSEDButton, entity))
                        this.childServiceHintboxMap.set(entity.ID, hintbox);
                        hintbox.on("change", lang.hitch(this, this._onChangeServiceHintbox, entity.ID));
                    }
                    hintbox.setValue(entity.childService, true);
                    hintbox.placeAt(node);
                }
                return true;
            case "createEvTaskBeyondChild":
                this.UiModder.domConstruct.empty(node);
                if (
                    entity.childService &&
                    entity.EL_vt_services_main_service?.length > 0 &&
                    entity.childService.EL_ht_service_ev_serv_ev_task_descript_service?.length > 0
                ) {
                    var checkbox: MdsLax<InstanceType<typeof CheckBox>> = this.serviceCheckboxMap.get(entity.ID);
                    if (!checkbox) {
                        checkbox = new CheckBox();
                        this.serviceCheckboxMap.set(entity.ID, checkbox);
                        checkbox.on("change", lang.hitch(this, this._onChangeServiceCheckbox, entity.ID, "child"));
                    }
                    checkbox.setValue(entity.childService.createEvTaskBeyond, true);
                    checkbox.placeAt(node);
                }
                return true;
        }
        return false;
    }

    private serviceStore: MdsLax<InstanceType<typeof EntityStore<VAM2types.EvService>>>;

    private _onChangeServiceCheckbox(entityId: string, mode: "parent" | "child", value: boolean) {
        let copy = lang.clone(this.serviceStore.getEntityById(entityId));
        if (mode === "parent") copy.createEvTaskBeyond = value;
        else copy.childService.createEvTaskBeyond = value;
        this.serviceStore.changeEntry(copy, true);
    }

    private _onChangeServiceHintbox(entityId: string, childService: VAM2types.EvService) {
        let copy = lang.clone(this.serviceStore.getEntityById(entityId));
        copy.childService = childService;
        this.serviceStore.changeEntry(copy, true);
    }

    private _onClickSEDButton(entity: VAM2types.EvService, evt: MouseEvent) {
        this.showSelectEntityDialog(evt, "selectChildService", lang.hitch(this, this._onCallbackSED, entity), null, {service: entity});
    }

    private _onCallbackSED(entity: VAM2types.EvService, mode: string, data: Array<string>, items: Array<SelectEntityDialogTypes.Item<VAM2types.EvService>>) {
        switch (mode) {
            case "selectChildService":
                if (items && items?.length > 0) {
                    let hintbox = this.childServiceHintboxMap.get(entity?.ID);
                    if (hintbox) hintbox.setValue(items[0].entry.data);
                }
                break;
        }
    }

    setup(evServiceList: Array<VAM2types.EvService>, tabContainer?: MdsLax<InstanceType<typeof TabContainer>>,  node?: HTMLElement) {
        let heading;

        this.internalName = "EvServiceConfigPanel_" + StringHelpers.randomID();
        heading = `${this.translate("EvService_Heading_EvServiceConfigPanel")}`;

        this.childServiceHintboxMap = new Map();
        this.serviceCheckboxMap = new Map();

        this.serviceStore.setup(evServiceList);
        this.serviceTable = new StaticTable();
        this.serviceTable.setLayout(this.serviceTableConfig);
        this.serviceTable.setFormatter(lang.hitch(this, this.serviceTableFormatter));
        this.serviceTable.setupFromStore(this.serviceStore);
        this.serviceTable.placeAt(this.tableContainer);

        if (node) {
            this.show("node", heading, node)
        } else if (tabContainer) {
            this.show("tab", heading, tabContainer.name);
        }
        else {
            this.show("dlg", heading);
            this.createDefaultButton("ok", lang.hitch(this, this._onCloseRequest));
        }
    }

    //UIFRAMEMIXIN
    //UIFRAMEMIXIN
    _onCloseRequest() {
        let dlgConfirm = new GenericDialog();
        dlgConfirm.show(this.translate("EvServiceConfigPanel_Message_AskConfirmChanges"), 
            this.translate("EvServiceConfigPanel_Heading_AskConfirmChanges"),
            "",
            "",
            "yesnocancel",
            lang.hitch(this, this._confirmCallback));

        return false;
    }

    private _confirmCallback(result) {
        if (result === 2) {
            this.emit("confirmed", this.serviceStore.getCurrentCompleteList());
            this.close();
        }
        else if (result === -1) {
            this.close();
        }
    }

    //WIDGETBASE
    postCreate(): void {
        super.postCreate.apply(this, arguments as any);

        this.SEDconfigCallfunction = "Webtool_API_EvBooking__SED_GetConfig";

        this.serviceStore = new EntityStore();
    }

    startup(): void {
        super.startup.apply(this, arguments as any);
    }
}

export default mdsWidget(EvServiceConfigPanel);